import styled from 'styled-components';

import { units } from '@calm-web/design-system';

import { APP_SIDEBAR_INDEX } from '@/utils/ui/zIndices';

export const Wrapper = styled.div`
	display: flex;
	gap: ${units(2)};

	div[data-tippy-root] {
		z-index: ${APP_SIDEBAR_INDEX} !important;
	}
`;
